<template>
  <section class="radar">
    <SectionTitle
      :title="`${targetArea}の雨雲レーダー`"
      :button-link="link"
    />
    <div class="content">
      <a :href="link">
        <img
          :src="src"
          loading="lazy"
          alt="雨雲レーダー"
        >
      </a>
    </div>
  </section>
</template>

<script setup>
defineProps({
  link: {
    type: String,
    required: true
  },
  src: {
    type: String,
    required: true
  },
  targetArea: {
    type: String,
    required: true
  }
})
</script>

<style lang="scss" scoped>
.radar {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.content {
  img {
    width: 100%;
    max-width: 100%;
    aspect-ratio: 1480 / 832;
  }
}
</style>
